import { createContext, useContext } from "react";

export type NotificationRoutingContextValue = {
  responseReady: boolean;
  hasPendingNotificationIntent: boolean;
};

export const NotificationRoutingContext = createContext<NotificationRoutingContextValue>({
  responseReady: false,
  hasPendingNotificationIntent: false,
});

export function useNotificationRouting() {
  return useContext(NotificationRoutingContext);
}
